module.exports = __webpack_public_path__ + "img/home-trend-up.002fa516.svg";